import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { useIntake } from '../../context/IntakeContext';
import { RadioGroup } from '../ui/RadioGroup';
import { CheckboxGroup } from '../ui/CheckboxGroup';
import { Textarea } from '../ui/Textarea';
import { MascotPanel } from '../ui/MascotPanel';
import { LabelWithInfo } from '../ui/LabelWithInfo';
export function Step13SEO() {
  const {
    data,
    updateData
  } = useIntake();
  const isSeoImportant = data.seoServices === 'high' || data.seoServices === 'medium';
  const googleBusinessTasks = [{
    value: 'photos',
    label: "Foto's uploaden"
  }, {
    value: 'blogs',
    label: 'Blogs / Updates plaatsen'
  }, {
    value: 'info',
    label: 'Bedrijfsinformatie juist zetten'
  }];
  const socialAdsOptions = [{
    value: 'instagram',
    label: 'Instagram'
  }, {
    value: 'facebook',
    label: 'Facebook'
  }, {
    value: 'tiktok',
    label: 'TikTok'
  }, {
    value: 'linkedin',
    label: 'LinkedIn'
  }, {
    value: 'pinterest',
    label: 'Pinterest'
  }];
  return <motion.div initial={{
    opacity: 0,
    y: 20
  }} animate={{
    opacity: 1,
    y: 0
  }} exit={{
    opacity: 0,
    y: -20
  }} className="max-w-3xl mx-auto space-y-8" data-id="element-131" data-mp="dtdw862tvj7k">
      <MascotPanel message="Een website is pas succesvol als hij gevonden wordt. Hoe belangrijk is Google voor uw bedrijf?" detailedInfo="SEO (Zoekmachine Optimalisatie) zorgt ervoor dat uw website hoger in Google komt. Als u dit belangrijk vindt, kunnen we een uitgebreid onderzoek doen naar zoektermen, een SEO silo opzetten (een slimme websitestructuur), of u helpen met blogs en Google Bedrijfsprofiel. Als u kiest voor 'Niet zo belangrijk', installeren we standaard Yoast SEO voor de basis." data-id="element-132" data-mp="3va5jhayzfgaw" />

      <div className="bg-white rounded-3xl shadow-sm border border-gray-100 p-8 space-y-8" data-id="element-133" data-mp="37lma0s474xh8">
        <h2 className="text-2xl font-bold text-gray-900" data-id="element-134" data-mp="1bihnnqvy17e2">Vindbaarheid (SEO)</h2>

        <div data-id="element-135" data-mp="1ggj7ie171aql">
          <LabelWithInfo label="Hoe belangrijk is vindbaarheid in Google voor u?" tooltip="SEO staat voor Search Engine Optimization (zoekmachine optimalisatie). Het zorgt ervoor dat uw website hoger verschijnt in Google wanneer potentiële klanten zoeken naar uw diensten of producten." data-id="element-136" data-mp="1gfzmupk5s88v" />
          <RadioGroup columns={1} value={data.seoServices} onChange={val => updateData({
          seoServices: val
        })} options={[{
          value: 'high',
          label: 'Zeer belangrijk',
          description: 'We willen actief groeien via Google en concurrenten verslaan'
        }, {
          value: 'medium',
          label: 'Belangrijk',
          description: 'De basis moet goed staan voor relevante zoektermen'
        }, {
          value: 'low',
          label: 'Niet zo belangrijk',
          description: 'Klanten komen voornamelijk via ons eigen netwerk (Standaard Yoast SEO)'
        }]} data-id="element-137" data-mp="sk5azv5tpfdq" />
        </div>

        <AnimatePresence data-id="element-138" data-mp="2ea21i5a3m2k5">
          {isSeoImportant && <motion.div initial={{
          opacity: 0,
          height: 0
        }} animate={{
          opacity: 1,
          height: 'auto'
        }} exit={{
          opacity: 0,
          height: 0
        }} className="space-y-8 pt-6 border-t border-gray-100 overflow-hidden" data-id="element-139" data-mp="29bh8apt9kj57">
              <h3 className="text-xl font-bold text-gray-900" data-id="element-140" data-mp="3tprd1a460t5q">
                Uitgebreide SEO Wensen
              </h3>

              <Textarea label="Op welke zoektermen wilt u idealiter gevonden worden?" infoTooltip="Denk aan de woorden die uw ideale klant intypt in Google als ze op zoek zijn naar uw diensten. Bijv. 'Loodgieter Amsterdam' of 'Schoenen kopen online'." placeholder="Als u ze al weet, vul ze in. Anders doen wij onderzoek..." value={data.seoSearchTerms} onChange={e => updateData({
            seoSearchTerms: e.target.value
          })} data-id="element-141" data-mp="3pq8ps7ovg5zq" />

              <Textarea label="Wie zijn uw belangrijkste concurrenten online?" infoTooltip="Met de namen of websites van uw concurrenten kunnen we analyseren op welke zoektermen zij scoren en waar kansen voor u liggen." placeholder="Bijv. 'www.concurrent-a.nl, Bedrijf B uit Haarlem'..." value={data.seoCompetitors} onChange={e => updateData({
            seoCompetitors: e.target.value
          })} data-id="element-142" data-mp="3iugy7ox39h8j" />

              <Textarea label="In welke regio's of steden wilt u gevonden worden?" infoTooltip="Lokale SEO combineert uw diensten met specifieke regio's. Zo kunt u per stad of regio hoog scoren in Google." placeholder="Bijv. 'Alkmaar, Haarlem, Amsterdam, Noord-Holland' of 'Heel Nederland'." value={data.seoSiloRegions} onChange={e => updateData({
            seoSiloRegions: e.target.value
          })} data-id="element-143" data-mp="2bhrulqg5tv0c" />

              <div data-id="element-144" data-mp="394h1oeppyxt2">
                <LabelWithInfo label="Wat voor zoekwoordenonderzoek wilt u?" tooltip="Bij zoekwoordenonderzoek analyseren we welke woorden en zinnen uw doelgroep gebruikt in Google. 'Long-tail' zoektermen zijn langere, specifiekere zoekopdrachten (bijv. 'beste loodgieter spoedservice Amsterdam') die minder concurrentie hebben en vaak beter converteren." data-id="element-145" data-mp="397398ecm1dba" />
                <RadioGroup columns={1} value={data.seoKeywordResearch} onChange={val => updateData({
              seoKeywordResearch: val
            })} options={[{
              value: 'extensive',
              label: 'Uitgebreid onderzoek (inclusief long-tail zoektermen)'
            }, {
              value: 'small',
              label: 'Klein basis onderzoek'
            }, {
              value: 'none',
              label: 'Niet nodig, ik weet de termen al'
            }]} data-id="element-146" data-mp="2fsk5jaz38v5u" />
              </div>

              <div data-id="element-147" data-mp="1d6qklirnt6gg">
                <LabelWithInfo label="Wilt u een SEO Silo structuur?" tooltip="Een SEO silo is een slimme manier om uw website te organiseren. Gerelateerde pagina's worden gegroepeerd in 'silo's' (thema's), waardoor Google beter begrijpt waar uw website over gaat. Dit kan uw positie in zoekresultaten flink verbeteren." data-id="element-148" data-mp="1d67d6vzmy0go" />
                <RadioGroup columns={2} value={data.seoSilo} onChange={val => updateData({
              seoSilo: val
            })} options={[{
              value: 'yes',
              label: 'Ja, stel een silo in'
            }, {
              value: 'no',
              label: 'Nee, niet nodig'
            }, {
              value: 'dont_know',
              label: 'Weet ik niet, adviseer mij'
            }]} data-id="element-149" data-mp="rvt2zxc0z3fp" />

                <AnimatePresence data-id="element-150" data-mp="1z6shtj3ulozp">
                  {(data.seoSilo === 'yes' || data.seoSilo === 'dont_know') && <motion.div initial={{
                opacity: 0,
                height: 0
              }} animate={{
                opacity: 1,
                height: 'auto'
              }} exit={{
                opacity: 0,
                height: 0
              }} className="mt-6 space-y-6 overflow-hidden" data-id="element-151" data-mp="237uhg11og327">
                      <div data-id="element-152" data-mp="2877ch92pcgfv">
                        <LabelWithInfo label="Welk silo-pakket past bij u?" tooltip="Noord Digital biedt drie SEO silo-pakketten aan, afhankelijk van de omvang van uw website en uw ambities in Google." data-id="element-153" data-mp="2d7l9zx6og7zn" />
                        <RadioGroup columns={1} value={data.seoSiloPackage} onChange={val => updateData({
                    seoSiloPackage: val
                  })} options={[{
                    value: 'silver',
                    label: 'Zilver — Regionale groei',
                    description: "SEO silo — groot formaat, 100+ pagina's. Noord-Holland breed. Inclusief uitgebreide blog-clusters, review campagne, social media advies en autoriteitsprofielen volledig."
                  }, {
                    value: 'gold',
                    label: <div className="flex items-center" data-id="element-155" data-mp="1qrlciqty6k0a">
                                  Goud — Ads + SEO data-loop
                                  <span className="ml-3 inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-amber-100 text-amber-800 border border-amber-200" data-id="element-156" data-mp="3rl42kob93nhf">
                                    Meest gekozen
                                  </span>
                                </div>,
                    description: 'Alles van Zilver + Google Ads beheer, ads-data voedt de silo, keyword finetuning, maandelijkse rapportage, conversiemeting en leads optimalisatie.'
                  }, {
                    value: 'platinum',
                    label: 'Platinum — Maatwerk & exclusief',
                    description: 'Alles van Goud + heatmaps & tracking, call tracking, marktexclusiviteit*, A/B testing website, uitgebreide dashboards en persoonlijke groeistrategie. *Wij helpen geen enkel ander bedrijf in jouw directe markt.'
                  }]} data-id="element-154" data-mp="u9goopqwslxq" />
                      </div>

                      <Textarea label="Hoeveel hoofd-diensten of -thema's wilt u targeten?" infoTooltip="Geef de belangrijkste diensten of thema's op die u als aparte silo's wilt inrichten. Elke silo wordt een groep van gerelateerde pagina's." placeholder="Bijv. 'Belastingadvies, estate planning, pensioenadvies' of 'Loodgieter, CV-ketel, ontstopping'." value={data.seoSiloThemes} onChange={e => updateData({
                  seoSiloThemes: e.target.value
                })} data-id="element-157" data-mp="2fz51nl6bqdho" />
                    </motion.div>}
                </AnimatePresence>
              </div>

              <div data-id="element-158" data-mp="3hkbkj6a91ey5">
                <LabelWithInfo label="Wilt u dat wij SEO-geoptimaliseerde blogposts schrijven?" tooltip="Regelmatige blogposts helpen uw website hoger in Google te komen. Google beloont websites die regelmatig nieuwe, relevante content publiceren. Elke blogpost is een extra kans om gevonden te worden op nieuwe zoektermen." data-id="element-159" data-mp="1hfz79wx5hmsj" />
                <RadioGroup columns={2} value={data.seoBlogposts} onChange={val => updateData({
              seoBlogposts: val
            })} options={[{
              value: 'yes',
              label: 'Ja, graag'
            }, {
              value: 'no',
              label: 'Nee, doe ik zelf'
            }]} data-id="element-160" data-mp="1mczdq8xwwrk6" />

                <AnimatePresence data-id="element-161" data-mp="azdravjft42c">
                  {data.seoBlogposts === 'yes' && <motion.div initial={{
                opacity: 0,
                height: 0
              }} animate={{
                opacity: 1,
                height: 'auto'
              }} exit={{
                opacity: 0,
                height: 0
              }} className="mt-4 overflow-hidden" data-id="element-162" data-mp="2mmgz1cad2efd">
                      <label className="block text-sm font-semibold text-gray-900 mb-3" data-id="element-163" data-mp="3abjqfbusrln2">
                        Hoe vaak wilt u dat wij een blogpost plaatsen?
                      </label>
                      <RadioGroup columns={2} value={data.seoBlogFrequency} onChange={val => updateData({
                  seoBlogFrequency: val
                })} options={[{
                  value: 'daily',
                  label: 'Elke dag'
                }, {
                  value: 'weekly',
                  label: '1x per week'
                }, {
                  value: 'biweekly',
                  label: '1x per twee weken'
                }, {
                  value: 'monthly',
                  label: '1x per maand'
                }]} data-id="element-164" data-mp="31b3ow7xm6oku" />
                    </motion.div>}
                </AnimatePresence>
              </div>

              <div data-id="element-165" data-mp="13r8jrodb63jb">
                <LabelWithInfo label="Wilt u dat de zoekwoorden regelmatig geanalyseerd en aangepast worden?" tooltip="Google's algoritme verandert continu en uw concurrenten zitten ook niet stil. Door regelmatig te analyseren welke zoektermen goed presteren en welke niet, kunnen we uw strategie bijsturen voor optimaal resultaat." data-id="element-166" data-mp="13nknwike551f" />
                <RadioGroup columns={2} value={data.seoActiveUpdates} onChange={val => updateData({
              seoActiveUpdates: val
            })} options={[{
              value: 'monthly',
              label: 'Ja, maandelijks'
            }, {
              value: 'yearly',
              label: 'Ja, jaarlijks'
            }, {
              value: 'no',
              label: 'Nee, eenmalige setup is genoeg'
            }]} data-id="element-167" data-mp="3jdb3uasamcxt" />
              </div>

              <div data-id="element-168" data-mp="3g0jpr4dg9wm6">
                <LabelWithInfo label="Wilt u inzicht in waar bezoekers klikken en kijken (Heatmaps)?" tooltip="Heatmaps zijn visuele kaarten die laten zien waar bezoekers op uw website klikken, scrollen en kijken. Hiermee ziet u precies welke onderdelen van uw pagina aandacht krijgen en welke genegeerd worden — cruciaal om uw website te verbeteren." data-id="element-169" data-mp="3g1uqswfigq9l" />
                <RadioGroup columns={2} value={data.seoHeatmapsUrgency} onChange={val => updateData({
              seoHeatmapsUrgency: val
            })} options={[{
              value: 'yes',
              label: 'Ja, ik wil dit inzicht'
            }, {
              value: 'no',
              label: 'Nee, niet nodig'
            }, {
              value: 'advise',
              label: 'Weet ik niet, adviseer mij'
            }]} data-id="element-170" data-mp="2t8e4i3s1es2" />
              </div>

              <div data-id="element-171" data-mp="r7kz847wmes0">
                <LabelWithInfo label="Wilt u verschillende versies van uw website testen (A/B Testing)?" tooltip="Bij A/B testing tonen we twee verschillende versies van een pagina aan verschillende bezoekers. Zo ontdekken we welke versie beter werkt — bijv. welke knopkleur of tekst meer aanvragen oplevert. Dit is de meest wetenschappelijke manier om uw conversie te verhogen." data-id="element-172" data-mp="r606mk55h5ws" />
                <RadioGroup columns={2} value={data.seoABTestingUrgency} onChange={val => updateData({
              seoABTestingUrgency: val
            })} options={[{
              value: 'yes',
              label: 'Ja, ik wil testen'
            }, {
              value: 'no',
              label: 'Nee, niet nodig'
            }, {
              value: 'advise',
              label: 'Weet ik niet, adviseer mij'
            }]} data-id="element-173" data-mp="7kvmjik70ft8" />
              </div>

              <div data-id="element-174" data-mp="1o3tvq8wxnh">
                <LabelWithInfo label="Wilt u extra training over uw website, SEO en bedrijfsprofielen?" tooltip="Bij oplevering krijgt u altijd een basistraining. Met extra training leert u zelf hoe u blogs plaatst, reageert op reviews, uw Google profiel bijhoudt en de SEO-prestaties monitort. Zo bent u zelfstandig en bespaart u op de lange termijn." data-id="element-175" data-mp="27b8ii9s3n9" />
                <RadioGroup columns={2} value={data.seoTraining} onChange={val => updateData({
              seoTraining: val
            })} options={[{
              value: 'yes',
              label: 'Ja, ik wil extra training'
            }, {
              value: 'no',
              label: 'Nee, basis is voldoende'
            }]} data-id="element-176" data-mp="3depsdic0gws2" />
              </div>

              <div className="pt-6 border-t border-gray-100" data-id="element-177" data-mp="155t4o8fq04l4">
                <h3 className="text-xl font-bold text-gray-900 mb-6" data-id="element-178" data-mp="19aajrub4xtpk">
                  Bedrijfsprofielen & Advertenties
                </h3>

                <div className="mb-6" data-id="element-179" data-mp="1e6r74maig41l">
                  <LabelWithInfo label="Wilt u hulp met uw Google Bedrijfsprofiel?" tooltip="Uw Google Bedrijfsprofiel (voorheen Google Mijn Bedrijf) is het informatieblok dat rechts verschijnt als iemand uw bedrijfsnaam googelt. Het toont uw adres, openingstijden, reviews en foto's. Een goed onderhouden profiel vergroot uw lokale vindbaarheid enorm." data-id="element-180" data-mp="1izkap6u8t6c3" />
                  <RadioGroup columns={2} value={data.seoGoogleBusiness} onChange={val => updateData({
                seoGoogleBusiness: val
              })} options={[{
                value: 'yes',
                label: 'Ja'
              }, {
                value: 'no',
                label: 'Nee'
              }]} data-id="element-181" data-mp="1xu0djfm7wl8" />

                  <AnimatePresence data-id="element-182" data-mp="3p4mkeuvxd6f0">
                    {data.seoGoogleBusiness === 'yes' && <motion.div initial={{
                  opacity: 0,
                  height: 0
                }} animate={{
                  opacity: 1,
                  height: 'auto'
                }} exit={{
                  opacity: 0,
                  height: 0
                }} className="mt-4 overflow-hidden" data-id="element-183" data-mp="2rnnxns0sen6s">
                        <label className="block text-sm font-semibold text-gray-900 mb-3" data-id="element-184" data-mp="2a8ut5eljjtu1">
                          Wat wilt u dat wij doen voor uw Google profiel?
                        </label>
                        <CheckboxGroup columns={1} options={googleBusinessTasks} values={data.seoGoogleBusinessTasks} onChange={vals => updateData({
                    seoGoogleBusinessTasks: vals
                  })} data-id="element-185" data-mp="21cdiech39xyt" />
                      </motion.div>}
                  </AnimatePresence>
                </div>

                <div className="mb-6" data-id="element-186" data-mp="1cu3de2ik82dx">
                  <LabelWithInfo label="Wilt u ook hulp met uw Apple Bedrijfsprofiel (Apple Maps)?" tooltip="Apple Maps wordt standaard gebruikt op iPhones en iPads. Een Apple Bedrijfsprofiel zorgt dat uw bedrijf ook daar correct en compleet wordt weergegeven — belangrijk aangezien meer dan de helft van de Nederlanders een iPhone gebruikt." data-id="element-187" data-mp="1cv4y6ypdo38u" />
                  <RadioGroup columns={2} value={data.seoAppleBusiness} onChange={val => updateData({
                seoAppleBusiness: val
              })} options={[{
                value: 'yes',
                label: 'Ja'
              }, {
                value: 'no',
                label: 'Nee'
              }]} data-id="element-188" data-mp="1vj9y1v2wz42d" />

                  <AnimatePresence data-id="element-189" data-mp="2kl0m9oxqpaxo">
                    {data.seoAppleBusiness === 'yes' && <motion.div initial={{
                  opacity: 0,
                  height: 0
                }} animate={{
                  opacity: 1,
                  height: 'auto'
                }} exit={{
                  opacity: 0,
                  height: 0
                }} className="mt-4 overflow-hidden" data-id="element-190" data-mp="2ybvxh7vpo44f">
                        <label className="block text-sm font-semibold text-gray-900 mb-3" data-id="element-191" data-mp="3r1cn5xry56wy">
                          Wat wilt u dat wij doen voor uw Apple profiel?
                        </label>
                        <CheckboxGroup columns={1} options={googleBusinessTasks} values={data.seoAppleBusinessTasks} onChange={vals => updateData({
                    seoAppleBusinessTasks: vals
                  })} data-id="element-192" data-mp="1vl4hccv944ao" />
                      </motion.div>}
                  </AnimatePresence>
                </div>

                <div className="mb-6" data-id="element-193" data-mp="2jibo46osh7af">
                  <LabelWithInfo label="Wilt u adverteren via Google Ads (SEA)?" tooltip="Google Ads (SEA = Search Engine Advertising) zijn de betaalde advertenties bovenaan de Google zoekresultaten. In tegenstelling tot SEO (organisch) betaalt u per klik. Het voordeel: u bent direct zichtbaar voor uw doelgroep. Het nadeel: zodra u stopt met betalen, verdwijnt u weer." data-id="element-194" data-mp="2jh0h7y01rjf3" />
                  <RadioGroup columns={2} value={data.seoGoogleAds} onChange={val => updateData({
                seoGoogleAds: val
              })} options={[{
                value: 'yes',
                label: 'Ja'
              }, {
                value: 'no',
                label: 'Nee'
              }, {
                value: 'advise',
                label: 'Adviseer mij'
              }]} data-id="element-195" data-mp="qlzkod2zwx4x" />
                </div>

                <div data-id="element-196" data-mp="vkswm12mwg2z">
                  <LabelWithInfo label="Wilt u advertenties draaien op Social Media?" tooltip="Social media advertenties verschijnen in de feeds van uw doelgroep op platforms als Instagram, Facebook en LinkedIn. U kunt zeer gericht targeten op leeftijd, locatie, interesses en gedrag. Ideaal om naamsbekendheid te vergroten of specifieke acties te promoten." data-id="element-197" data-mp="vjhus6sr1iei" />
                  <CheckboxGroup columns={2} options={socialAdsOptions} values={data.seoSocialAds} onChange={vals => updateData({
                seoSocialAds: vals
              })} data-id="element-198" data-mp="1ye6inz71w3j6" />
                </div>

                <div className="mt-6 p-4 bg-gray-50 rounded-xl text-sm text-gray-600" data-id="element-199" data-mp="1tg4y19tz7w5l">
                  <strong data-id="element-200" data-mp="1fgna0woi8mxa">Opmerking:</strong> Zaken zoals technische SEO en LLM
                  SEO (AI search) worden automatisch door ons en Yoast SEO
                  meegenomen.
                </div>
              </div>
            </motion.div>}
        </AnimatePresence>
      </div>
    </motion.div>;
}